let $ks = {
    //////////////////////
    // DOM 제어 및 판단 //
    //////////////////////

    // create element
    ce(opts) { // CE({ tag: "style", id: "thisId" class: "hey", targetElement: QS("head"), attribute: { type: "text/css" } })
        let element;
        element = document.createElement(opts.tag);
        if (opts.id) element.setAttribute('id', opts.id);
        if (opts.class) {
            if (opts.class.indexOf(' ') > -1) {
                let classNameArray = opts.class.split(' ');
                classNameArray.forEach((className) => { element.classList.add(className); });
            } else {
                element.classList.add(opts.class);
            }

        }
        if (opts.targetElement) opts.targetElement.appendChild(element);
        if (opts.targetElement && opts.insertBeforeRefEl) opts.targetElement.insertBefore(element, opts.insertBeforeRefEl);
        if (opts.attribute) {
            for (var attrName in opts.attribute) {
                element.setAttribute(attrName, opts.attribute[attrName]);
            }
        }
        return element;
    },

    // create svg element
    ceSvg(tag, targetElement) {
        let svgElement = document.createElementNS('http://www.w3.org/2000/svg', tag);
        targetElement.appendChild(svgElement);
        return svgElement;
    },

    // remove element
    removeElement(element) { if (element) element.parentNode.removeChild(element); },

    // getElementById
    getById(id, parentElement = document) { return parentElement.getElementById(id); },

    // getElementsByTagName
    getByTag(tagName, parentElement = document, index) {
        let result;
        result = Array.from(parentElement.getElementsByTagName(tagName));
        result = (index || index === 0) ? result[index] : result;
        return result;
    },

    // getElementsByClassName
    getByClass(className, parentElement = document, index) {
        let result;
        result = Array.from(parentElement.getElementsByClassName(className));
        result = (index || index === 0) ? result[index] : result;
        return result;
    },

    // querySelector
    qs(query, parentElement = document) { return parentElement.querySelector(query); },

    // querySelectorAll
    qsall(query, parentElement = document) { return Array.from(parentElement.querySelectorAll(query)); },

    // class 제어
    addClass (element, className) { className = className.split(' '); for (var i = 0; i < className.length; i++) element.classList.add(className[i]); },
    removeClass (element, className) { className = className.split(' '); for (var i = 0; i < className.length; i++) element.classList.remove(className[i]); },
    hasClass (element, className) { return element.classList.contains(className); },

    getRandomNumber(max, min = 0) { return Math.floor(Math.random() * max) + min },

    addHoverEvents(target, options) {
        let addEvent = (eType, classType) => {
            target.addEventListener(eType, (e) => {
                if (options) {
                    if (options.preventDefault) e.preventDefault();
                    if (options.additionalFn) options.additionalFn(e);
                }
                if (classType === 'add') this.addClass(target, 'hover');
                else this.removeClass(target, 'hover');
            }, false);
        };
        addEvent('mouseenter', 'add');
        addEvent('mouseleave', 'remove');
    },

    addDownEvents(target, options) {
        let addEvent = (eType, classType) => {
            target.addEventListener(eType, (e) => {
                if (options) {
                    if (options.preventDefault) e.preventDefault();
                    if (options.additionalFn) options.additionalFn(e, classType);
                }
                if (classType === 'add') this.addClass(target, 'clicked');
                else this.removeClass(target, 'clicked');
            }, false);
        };
        addEvent('mousedown', 'add');
        addEvent('touchstart', 'add');
        addEvent('mouseleave', 'remove');
        addEvent('touchcancel', 'remove');
        addEvent('mouseup', 'remove');
        addEvent('touchend', 'remove');
    },

    addFocusEvents(target, options) {
        let addEvent = (eType, classType) => {
            target.addEventListener(eType, (e) => {
                if (options) {
                    if (options.preventDefault) e.preventDefault();
                }
                if (classType === 'add') this.addClass(target, 'focused');
                else this.removeClass(target, 'focused');
            }, false);
        };
        addEvent('focus', 'add');
        addEvent('blur', 'remove');
    },

    summingNumberArray(array) { return array.reduce((accumulator, currentValue) => accumulator + currentValue); },

    getSize (target, size) {
        var value;
        switch (size) {
            case 'width':  value = target.getBoundingClientRect().width; break;
            case 'height': value = target.getBoundingClientRect().height; break;
            case 'top':    value = target.getBoundingClientRect().top; break;
            case 'left':   value = target.getBoundingClientRect().left; break;
            case 'right':  value = target.getBoundingClientRect().right; break;
            case 'bottom': value = target.getBoundingClientRect().bottom; break;
        }
        return value;
    },

    XYtransforming(target, x, y) {
        if (!target) return;
        target.style.transform = `translate(${x}px, ${y}px)`;
        target.style.msTransform = `translate(${x}px, ${y}px)`;
        target.style.webkitTransform = `translate(${x}px, ${y}px)`;
    },

    loadScriptFile(cssSrc, callBack) {
        var script = document.createElement('script');
        script.src = cssSrc;

        if (callBack) {
            script.onload = function () {
                callBack();
            };
        }
        document.body.appendChild(script);
    },

    loadCssFile(cssSrc, callBack) {
        var css = document.createElement("link");
        css.setAttribute("rel", "stylesheet");
        css.setAttribute("type", "text/css");
        css.setAttribute("href", cssSrc);

        document.head.appendChild(css);
    },

    timeNow() { return new Date().getTime(); },

    bodyLog(msg, opts) {
        var logbox = document.getElementById('bodyLogBox') ? document.getElementById('bodyLogBox') : this.ce({ tag: 'div', id: 'bodyLogBox', targetElement: document.body });
        logbox.style.position = 'fixed';
        logbox.style.right = 0;
        logbox.style.bottom = 0;

        if (opts && opts.clear) {
            logbox.innerHTML = msg;
        } else {
            logbox.innerHTML += '<br>';
            logbox.innerHTML += msg;
        }
    }
};

export default $ks;

//////////////////////
// DOM 제어 및 판단 //
//////////////////////

// class 제어 constructor
function $ClassControl(element){
    element.addClass = function (className) { className = className.split(' '); for (var i = 0; i < className.length; i++) element.classList.add(className[i]); }
    element.removeClass = function (className) { className = className.split(' '); for (var i = 0; i < className.length; i++) element.classList.remove(className[i]); }
    element.hasClass = function (className) { return element.classList.contains(className); }
}

// document 또는 parent에 query에 해당하는 element가 있는가?
function isThere (query, parent = document) { return parent.querySelectorAll(query).length !== 0; }

// object가 빈 값인가?
function isEmpty (object) { return object === undefined || object === null || object.length === 0 || Number.isNaN(object); }

// style tag에 css style 추가
function setStyles(JSON) {
    var styleTag, selectors, propertyPairs, allCssTexts;
    styleTag = this.getByTag('style') || this.ce({ tag: "style", targetElement: document.head, attribute: { type: "text/css" } });
    selectors = Object.keys(JSON);
    propertyPairs = this.getValues(JSON);
    allCssTexts = '';

    var selectorIndex, selectorCssText, names, values, nameIndex;
    for (selectorIndex = 0; selectorIndex < selectors.length; selectorIndex++) {
        selectorCssText = selectors[selectorIndex] + ' {';
        names = Object.keys(propertyPairs[selectorIndex]);
        values = this.getValues(propertyPairs[selectorIndex]);

        for (nameIndex = 0; nameIndex < names.length; nameIndex++) {
            selectorCssText += names[nameIndex] + ':' + values[nameIndex] + ';';
        }
        selectorCssText += '}';
        allCssTexts += selectorCssText;
    }
    styleTag.innerHTML = allCssTexts + styleTag.innerHTML;
}

// 현재 size 얻기
// function getSize (target, size) {
//     var value;
//     switch (size) {
//         case 'width':  value = target.getBoundingClientRect().width; break;
//         case 'height': value = target.getBoundingClientRect().height; break;
//         case 'top':    value = target.getBoundingClientRect().top; break;
//         case 'left':   value = target.getBoundingClientRect().left; break;
//         case 'right':  value = target.getBoundingClientRect().right; break;
//         case 'bottom': value = target.getBoundingClientRect().bottom; break;
//     }
//     return value;
// }

////////////
// object //
////////////

// 객체 value 얻기
function getValues(object) {
    var values = [];
    Object.keys(object).forEach((key) => {
        values.push(object[key]);
    });
    return values;
}

/////////////////////////////////////
// regExp, unicode, HTML entities //
/////////////////////////////////////

// 한글 유니코드 ㄱ,ㄴ,ㄷ 순
var initialRegExpArray = [/[\uAC00-\uB097]/, /[\uB098-\uB2E3]/, /[\uB2E4-\uB77B]/, /[\uB77C-\uB9C7]/, /[\uB9C8-\uBC13]/, /[\uBC14-\uC0AB]/, /[\uC0AC-\uC543]/, /[\uC544-\uC78F]/, /[\uC790-\uCC27]/, /[\uCC28-\uCE73]/, /[\uCE74-\uD0BF]/, /[\uD0C0-\uD30B]/, /[\uD30C-\uD557]/, /[\uD558-\uD7A3]/];

//////////////////
// JS animation //
//////////////////

function animate(opts) {
    var start = new Date,

        id = setInterval(function() {
            var timePassed = new Date - start,
                progress = timePassed / opts.duration;

            if (progress > 1)
                progress = 1;

            var delta = opts.delta(progress);
            opts.step(delta);

            if (progress === 1) {
                clearInterval(id)
            }

        }, opts.delay);

    GameManager.aniId = id;
}

function makeEaseInOut(delta) {
    return function(progress) {
        if (progress < .5) return delta(2 * progress) / 2;
        else return (2 - delta(2 * (1 - progress))) / 2;
    }
}

function makeEaseOut(delta) {
    return function(progress) {
        return 1 - delta(1 - progress);
    }
}

function elastic (progress) { return Math.pow(2,10 * (progress - 1)) * Math.cos(20 * Math.PI * 1.5 / 3 * progress); }
function linear (progress) { return progress; }
function quad (progress) { return Math.pow(progress, 2); }
function quint (progress) { return Math.pow(progress, 5); }
function circ (progress) { return 1- Math.sin(Math.acos(progress)); }
function back (progress) { return Math.pow(progress,2)*((1.5+ 1)*progress- 1.5); }
function bounce (progress) {
    for (var a = 0, b = 1; 1; a += b, b /= 2) {
        if (progress >= (7 - 4 * a) / 11) {
            return -Math.pow((11 - 6 * a - 11 * progress) / 4, 2) + Math.pow(b, 2);
        }
    }
}

function runAnimation (animateElement, stepAni, animateOption) {
    animate({
        delay : animateOption.delay,
        duration : animateOption.duration,
        delta :animateOption.delta,
        step : function(delta) {
            stepAni(animateElement, delta);
        }
    });
}





// effectSound
let efSound = (src) => {
    var efAudio = new Audio;
    var efPlay = function () {
        efAudio.removeEventListener('loadeddata', efPlay);
        efAudio.play();
    };
    efAudio.src = src;
    efAudio.addEventListener('loadeddata', efPlay);
    efAudio.load();
}

///////////
// EVENT //
///////////

var eventCheck = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;

var GameManager = {
    event: {
        isTouchDevice: 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch,
        eventSelector: function (eventType) {
            // console.log('□ this.isTouchDevice :', this.isTouchDevice);
            var selectedEvent;
            switch (eventType) {
                case 'eventDown':
                    selectedEvent = this.isTouchDevice ? 'touchstart' : 'mousedown';
                    break;
                case 'eventMove':
                    selectedEvent = this.isTouchDevice ? 'touchmove' : 'mousemove';
                    break;
                case 'eventUp':
                    selectedEvent = this.isTouchDevice ? 'touchend' : 'mouseup';
                    break;
                case 'eventOut':
                    selectedEvent = this.isTouchDevice ? 'touchleave' : 'mouseout';
                    break;
            }
            return selectedEvent;
        }
    }
};

function eventSelector (eventType, e) {
    var eventMaster;

    if (eventType === 'eventDown') {
        switch (GameManager.event.eventSelector('eventDown')) {
            case "mousedown":
                eventMaster = e;
                break;
            case "touchstart":
                e.preventDefault();
                eventMaster = e.touches.item(0);
                break;
        }
    } else if (eventType === 'eventMove') {
        switch (GameManager.event.eventSelector('eventMove')) {
            case "mousemove":
                eventMaster = e;
                break;
            case "touchmove":
                eventMaster = e.touches.item(0);
                break;
        }
    } else if (eventType === 'eventUp') {
        switch (GameManager.event.eventSelector('eventUp')) {
            case "mouseup":
                eventMaster = e;
                break;
            case "touchend":
                eventMaster = e.changedTouches[0];
                break;
        }
    } else if (eventType === 'eventOut') {
        switch (GameManager.event.eventSelector('eventOut')) {
            case "mouseout":
                eventMaster = e;
                break;
            case "touchleave":
                eventMaster = e.touches.item(0);
                break;
        }
    }
    return eventMaster;
};

function addEvent (target, eType, fnc) {
    var eventType;
    switch(eType){
        case 'mousedown': eventType = eventMaster.eventSelector('eventDown'); break;
        case 'mousemove': eventType = eventMaster.eventSelector('eventMove'); break;
        case 'mouseup':   eventType = eventMaster.eventSelector('eventUp'); break;
        case 'mouseout':  eventType = eventMaster.eventSelector('eventOut'); break;
        case 'click':  eventType = 'click'; break;
    }
    return target.addEventListener(eventType, fnc, false);
}
// removeEventListener
function removeEvent (target, eType, fnc) {
    var eventType;
    switch(eType){
        case 'mousedown': eventType = eventMaster.eventSelector('eventDown'); break;
        case 'mousemove': eventType = eventMaster.eventSelector('eventMove'); break;
        case 'mouseup':   eventType = eventMaster.eventSelector('eventUp'); break;
        case 'mouseout':  eventType = eventMaster.eventSelector('eventOut'); break;
        case 'click':  eventType = 'click'; break;
    }
    return target.removeEventListener(eventType, fnc, false);
}

// btn link (..ing)
function makeLinkBtns (btnData) { console.log('fn > makeLinkBtns'); console.log(btnData);
    var array = btnData instanceof Array ? btnData : [btnData];

    array.forEach(function(el){ new $LinkBtn(el); });
}

function $LinkBtn (object) { console.log('ctr > $LinkBtn'); console.log(object, this);
    this.btnClick = function(){
        window.open(object.linkUrl, '_self');
    }

    var eventType, fnc;
    eventType = (object.option && object.option.eventType) ? object.option.eventType : 'click';
    fnc = (object.option && object.option.fnc) ? object.option.fnc : this.btnClick;

    addEvent(object.btn, eventType, fnc);
}

///////////////////////////
// number, array, string //
///////////////////////////

// 배열 여러 개 합치기
function concatArrays(arrays) {
    var newArray = [];
    for (var i = 0; i < arrays.length; i++) newArray = newArray.concat(arrays[i]);
    return newArray;
}

// 천 단위마다 comma 찍는 함수
function insertComma(text) {
    text = text.toString();
    var output = '';

    do {
        if(text.length % 3 != 0) {
            output += text.slice(0, text.length % 3) + ',';
            text = text.slice(text.length % 3, text.length);
        } else {
            output += text.slice(0, 3) + ',';
            text = text.slice(3, text.length);
        }
    } while (text.length >= 4)

    output += text;

    return output;
}

// array 순서 섞어주는 함수
function stirElements(elements, length) {
    var numArray, newElements = [];
    numArray = length ? makeRandomArray(0, length) : makeRandomArray(0, elements.length);
    newElements = newElements.concat(elements);
    numArray.forEach(function(randomNumber, index) { newElements[index] = elements[randomNumber]; });
    return newElements;
}

// random number array 만들기
function makeRandomArray(min, length) {
    var randomNumber = 0, inspector = '', array = [];

    do {
        randomNumber = Math.floor(Math.random() * length) + min;
        if (inspector.indexOf(randomNumber) < 0) array.push(randomNumber);
        inspector += randomNumber.toString();
    } while (array.length !== length);

    return array;
}
